
import { mapGetters } from "vuex";

export default {
  computed: {
    isDesktop() {
      return this.$device.isDesktop;
    },
    ...mapGetters({
      settings: 'settings/settings/settings',
			isNight: "settings/settings/isNight"
		})
  },
  methods: {
    handleClick() {
      this.$emit('update:modalData');
    }
  }
};
